import { useEffect } from "react";

const BASE_URL = "https://oceanexports.in";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Updates document title, meta description, canonical link and Open Graph/Twitter
// tags per route. Googlebot renders JS (evergreen Chromium) so these client-side
// updates are picked up for indexing, giving every page its own unique SEO tags
// instead of sharing the single static index.html ones.
export function useSEO({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (noindex) {
      // Unknown routes (soft-404s) shouldn't claim a canonical URL of their own —
      // remove any existing tag so they aren't indexed as thin homepage duplicates.
      if (link) link.remove();
      return;
    }

    const canonicalUrl = `${BASE_URL}${path}`;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    if (title) setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonicalUrl);
  }, [title, description, path, noindex]);
}
